export const componentsEn: Record<string, string> = {
  '已处理:{{p0}} / {{p1}}': 'Processed: {{p0}} / {{p1}}',
  '失败: {{p0}}': 'Failed: {{p0}}',
  '开始时间: {{p0}}': 'Started: {{p0}}',
  '完成时间: {{p0}}': 'Completed: {{p0}}',
  '生成于 {{p0}}': 'Generated on {{p0}}',
  '当前名称：{{p0}}': 'Current name: {{p0}}',
  '过去 {{p0}} 天': 'Past {{p0}} days',
  '{{p0}} • {{p1}} 个': '{{p0}} • {{p1}} files',
  '使用默认桶{{p0}}': 'Use default bucket {{p0}}',
  'CSV 表格 - {{p0}} 行数据': 'CSV spreadsheet - {{p0}} rows',
  '{{p0}} 个文件': '{{p0}} files',
  '{{p0}} 个文件夹': '{{p0}} folders',
  '原始: {{p0}}': 'Original: {{p0}}',
  '压缩: {{p0}}': 'Compressed: {{p0}}',
  '压缩率:{{p0}}%': 'Compression ratio: {{p0}}%',
  '未找到匹配的{{p0}}': 'No matching {{p0}}',
  '{{p0}} 成员': '{{p0}} members',
  '您不是此{{p0}}的所有者，无法修改权限': 'You do not own this {{p0}} and cannot change its permissions',
  '版本 {{p0}}': 'Version {{p0}}',
  '创建于 {{p0}}': 'Created on {{p0}}',
  '已编辑 · 版本 {{p0}}': 'Edited · Version {{p0}}',
  '{{p0}} {{p1}} 条回复': '{{p0}} {{p1}} replies',
  '已选择 {{p0}} 项': '{{p0}} items selected',
  '+{{p0}} 更多': '+{{p0}} more',
  '共 {{p0}} 条授权记录': '{{p0}} permission records',
  '{{p0}} · {{p1}} 条授权': '{{p0}} · {{p1}} permissions',
  '授权于 {{p0}}': 'Granted on {{p0}}',
  '最后使用 {{p0}}': 'Last used {{p0}}',
  '过期时间 {{p0}}': 'Expires {{p0}}',
  '接收所有事件通知': 'Receive notifications for all events',
  '文件上传': 'File uploaded',
  '文件上传成功时触发': 'Triggered when a file is uploaded successfully',
  '文件删除': 'File deleted',
  '文件被删除时触发': 'Triggered when a file is deleted',
  '文件更新': 'File updated',
  '文件内容更新时触发': 'Triggered when file content is updated',
  '分享创建': 'Share created',
  '创建分享链接时触发': 'Triggered when a share link is created',
  '分享删除': 'Share deleted',
  '删除分享链接时触发': 'Triggered when a share link is deleted',
  '权限授予': 'Permission granted',
  '授予权限时触发': 'Triggered when permission is granted',
  '权限撤销': 'Permission revoked',
  '撤销权限时触发': 'Triggered when permission is revoked',
  '此文件夹及其中的文件将存储到「{{p0}}」': 'This folder and its files will be stored in "{{p0}}"',
  '共{{p0}}个版本 · 最多保留 {{p1}} 个版本 · 保留 {{p2}} 天': '{{p0}} versions · Maximum {{p1}} versions · Retained for {{p2}} days',
  '输入笔记内容...\n\n支持 Markdown 格式:\n**粗体** *斜体* ~~删除线~~ `代码`\n@user@example.com 提及用户': 'Enter note content...\n\nMarkdown supported:\n**bold** *italic* ~~strikethrough~~ `code`\n@user@example.com to mention a user',
  '保存成功': 'Saved successfully',
  '邮件配置已更新': 'Email configuration updated',
  '保存失败': 'Failed to save',
  '请检查配置': 'Check the configuration',
  '测试邮件已发送': 'Test email sent',
  '请检查收件箱': 'Check your inbox',
  '发送失败': 'Failed to send',
  '群发完成': 'Bulk email completed',
  '成功: {{p0}}, 失败: {{p1}}': 'Succeeded: {{p0}}, failed: {{p1}}',
  '群发失败': 'Failed to send bulk email',
  '请重试': 'Please try again',
  '邮件服务配置': 'Email service configuration',
  '配置Resend邮件服务，实现邮件验证、密码重置等功能': 'Configure Resend for email verification, password resets, and more',
  'Resend API 配置': 'Resend API configuration',
  '获取API Key:': 'Get an API key:',
  '(已配置)': '(Configured)',
  '留空保持现有配置，输入新值将覆盖': 'Leave blank to keep the current configuration, or enter a new value to replace it',
  '从Resend控制台获取API Key': 'Get an API key from the Resend dashboard',
  '发件人地址': 'Sender email address',
  '必须是在Resend中验证过的域名邮箱': 'Must use a domain verified in Resend',
  '发件人名称': 'Sender name',
  '保存中...': 'Saving...',
  '保存配置': 'Save configuration',
  '发送测试邮件': 'Send test email',
  '验证邮件服务是否正常工作': 'Check that the email service is working',
  '收件人地址（可选）': 'Recipient email address (optional)',
  '留空则发送到当前管理员邮箱': 'Leave blank to send to the current administrator',
  '发送中...': 'Sending...',
  '群发系统公告': 'Send system announcement',
  '向所有用户或特定角色用户发送邮件通知': 'Send email notifications to all users or selected roles',
  '目标用户': 'Recipients',
  '所有用户': 'All users',
  '仅管理员': 'Administrators only',
  '仅普通用户': 'Regular users only',
  '邮件主题': 'Email subject',
  '系统公告标题': 'System announcement title',
  '邮件内容': 'Email content',
  '邮件正文内容...': 'Email body...',
  '发送群发邮件': 'Send bulk email',
  '邮件服务未配置': 'Email service is not configured',
  '请先配置Resend API Key和发件人地址，然后保存配置。配置完成后即可使用：': 'Configure the Resend API key and sender address, then save. This enables:',
  '注册邮箱验证': 'Registration email verification',
  '忘记密码重置': 'Forgotten password resets',
  '更换邮箱确认': 'Email change confirmation',
  '系统通知邮件': 'System notification emails',
  '重新索引': 'Reindex',
  '建立索引': 'Create index',
  '当前没有正在运行的索引任务': 'No indexing task is running',
  '正在索引...': 'Indexing...',
  '索引完成': 'Indexing completed',
  '索引失败': 'Indexing failed',
  '已取消': 'Canceled',
  '取消任务': 'Cancel task',
  '清除状态': 'Clear status',
  '已处理:': 'Processed:',
  '失败:': 'Failed:',
  '开始时间:': 'Started:',
  '完成时间:': 'Completed:',
  'AI 功能': 'AI features',
  '配置 Cloudflare Workers AI 功能': 'Configure Cloudflare Workers AI features',
  'AI 功能未配置': 'AI features are not configured',
  '请在 Cloudflare Dashboard 中配置 AI 和 Vectorize 绑定': 'Configure AI and Vectorize bindings in the Cloudflare dashboard',
  '语义搜索索引': 'Semantic search index',
  '为文件建立向量索引以支持语义搜索': 'Create vector indexes for semantic file search',
  '一键生成索引': 'Generate indexes',
  '确认生成全量索引': 'Confirm indexing all files',
  '此操作将为所有未建立索引的文件生成向量索引，用于语义搜索功能。': 'This creates vector indexes for all unindexed files to enable semantic search.',
  '⚠️ 重要提示：': 'Important:',
  '此操作将处理您的所有文件数据': 'This processes all your file data',
  '任务将在后台异步执行，可能需要较长时间': 'The task runs in the background and may take some time',
  '大量文件可能消耗 AI API 配额': 'Large numbers of files may consume AI API quota',
  '索引期间可随时查看进度': 'You can check progress while indexing',
  '确认后，系统将在后台自动处理所有文件，您可以继续使用其他功能。': 'After confirmation, files are processed in the background. You can continue using other features.',
  '取消': 'Cancel',
  '确认开始': 'Confirm and start',
  'AI 摘要': 'AI summary',
  '暂无摘要，点击生成': 'No summary yet. Generate one below.',
  '重新生成': 'Regenerate',
  '生成': 'Generate',
  '生成于': 'Generated on',
  'AI 标签': 'AI tags',
  '暂无标签，点击生成': 'No tags yet. Generate them below.',
  '获取建议失败': 'Failed to get suggestions',
  '重命名失败': 'Failed to rename',
  '智能重命名': 'Smart rename',
  '当前名称：': 'Current name:',
  'AI 建议：': 'AI suggestions:',
  '暂无建议': 'No suggestions',
  '自定义名称：': 'Custom name:',
  '确认重命名': 'Confirm rename',
  '活跃度热力图': 'Activity heatmap',
  '过去': 'Past',
  '天': 'days',
  '上传': 'Upload',
  '下载': 'Download',
  '删除': 'Delete',
  '{{p0}}: 上传 {{p1}}, 下载 {{p2}}, 删除 {{p3}}': '{{p0}}: uploads {{p1}}, downloads {{p2}}, deletions {{p3}}',
  '少': 'Less',
  '多': 'More',
  '最近活动': 'Recent activity',
  '暂无文件': 'No files',
  '大文件 Top 20': 'Top 20 largest files',
  '占用存储空间最多的文件': 'Files using the most storage space',
  '未知类型': 'Unknown type',
  '查看': 'View',
  '存储分布': 'Storage distribution',
  '个': 'items',
  '按文件类型': 'By file type',
  '加载数据失败': 'Failed to load data',
  '重试': 'Retry',
  '概览': 'Overview',
  '活跃度': 'Activity',
  '大文件': 'Large files',
  '已使用空间': 'Used space',
  '文件数量': 'File count',
  '个文件': 'files',
  '文件夹数量': 'Folder count',
  '个文件夹': 'folders',
  '验证邮件已发送': 'Verification email sent',
  '请查收邮件并点击验证链接': 'Check your inbox and open the verification link',
  '请稍后重试': 'Please try again later',
  '邮箱未验证': 'Email not verified',
  '部分功能受限，请验证邮箱以解锁全部功能': 'Some features are restricted. Verify your email to unlock all features.',
  '重发验证邮件': 'Resend verification email',
  '关闭': 'Close',
  '加载失败': 'Failed to load',
  '加载文件失败': 'Failed to load file',
  '此文件类型不支持编辑': 'This file type cannot be edited',
  '内容未变化': 'No changes to save',
  '有未保存的更改，确定要关闭吗？': 'You have unsaved changes. Close anyway?',
  '未保存': 'Unsaved',
  '保存': 'Save',
  '保存更改': 'Save changes',
  '变更说明（可选）': 'Change description (optional)',
  '例如：修复拼写错误': 'For example: fix a spelling error',
  '输入内容...': 'Enter content...',
  '加载直链失败，请重试': 'Failed to load direct links. Please try again.',
  '请输入大于 0 的整数天数': 'Enter a positive whole number of days',
  '有效天数过大，请输入较小的天数': 'The duration is too large. Enter fewer days.',
  '操作失败': 'Operation failed',
  '有效期无效': 'Invalid validity period',
  '保存直链失败，请重试': 'Failed to save direct link. Please try again.',
  '有效期已更新，原链接保持不变': 'Validity updated. The existing links are unchanged.',
  '直链已创建': 'Direct link created',
  '确定要删除此直链吗？删除后该链接将立即失效。': 'Delete this direct link? It will stop working immediately.',
  '删除直链失败，请重试': 'Failed to delete direct link. Please try again.',
  '直链已删除': 'Direct link deleted',
  '{{p0}}链接已复制': '{{p0}} link copied',
  '复制失败，请重试或选中链接手动复制': 'Failed to copy. Try again or select and copy the link manually.',
  '永久有效': 'Never expires',
  '文件直链': 'File direct links',
  '文件：': 'File:',
  '正在加载直链...': 'Loading direct links...',
  '加载直链失败': 'Failed to load direct links',
  '重新加载': 'Reload',
  '链接用途': 'Link purpose',
  '下载链接': 'Download link',
  '预览链接': 'Preview link',
  '下载地址': 'Download URL',
  '预览地址': 'Preview URL',
  '复制链接': 'Copy link',
  '在新窗口打开': 'Open in new window',
  '访问后直接下载文件，无需登录。': 'Downloads the file directly without signing in.',
  '尝试在浏览器中预览；不支持的格式可能仍会下载。': 'Attempts to preview in the browser. Unsupported formats may download instead.',
  '过期时间：': 'Expires:',
  '（已过期）': '(Expired)',
  '此直链已过期，请更新有效期后再分享。': 'This direct link has expired. Update its validity before sharing.',
  '新的有效天数': 'New validity in days',
  '输入天数': 'Enter days',
  '处理中...': 'Processing...',
  '更新': 'Update',
  '设为永久有效': 'Set to never expire',
  '更新后的有效期从现在开始计算，不叠加原剩余时间；保留原 token，下载和预览链接均不变。': 'The new validity starts now and does not add to the remaining duration. The token and both links remain unchanged.',
  '删除直链': 'Delete direct link',
  '创建直链后，任何人都可以通过该链接直接下载文件，无需登录。': 'Anyone with a direct link can download the file without signing in.',
  '有效期（天）': 'Validity (days)',
  '默认 7 天': 'Default: 7 days',
  '创建中...': 'Creating...',
  '创建直链': 'Create direct link',
  '加载中...': 'Loading...',
  '暂无文件夹，请先创建文件夹': 'No folders. Create a folder first.',
  '点击加载文件夹列表': 'Load the folder list',
  '选择目标文件夹': 'Select destination folder',
  '确认选择': 'Confirm selection',
  '选择上传文件将保存到的文件夹': 'Select where uploaded files will be saved',
  '已选：': 'Selected:',
  '存储桶迁移': 'Bucket migration',
  '仅迁移已选中的': 'Migrate only the selected',
  '来源存储桶': 'Source bucket',
  '请选择来源存储桶': 'Select source bucket',
  '目标存储桶': 'Destination bucket',
  '请选择目标存储桶': 'Select destination bucket',
  '迁移后删除来源文件（移动模式）': 'Delete source files after migration (move mode)',
  '移动模式将在迁移成功后删除来源文件，此操作不可逆': 'Move mode deletes source files after successful migration. This cannot be undone.',
  '迁移中...': 'Migrating...',
  '迁移完成': 'Migration completed',
  '迁移失败': 'Migration failed',
  '成功': 'Succeeded',
  '失败': 'Failed',
  '启动中...': 'Starting...',
  '开始迁移': 'Start migration',
  '取消迁移': 'Cancel migration',
  '根目录': 'Root directory',
  '移动到…': 'Move to...',
  '目标：': 'Destination:',
  '已选文件夹': 'Selected folder',
  '移动中…': 'Moving...',
  '移动到这里': 'Move here',
  '纯文本': 'Plain text',
  '文本文件': 'Text files',
  '文档': 'Documents',
  '代码文件': 'Code files',
  '配置文件': 'Configuration files',
  'Web 开发': 'Web development',
  '新建文件': 'New file',
  '文件名称': 'File name',
  '输入文件名称': 'Enter file name',
  '文件类型': 'File type',
  '最终文件名:': 'Final file name:',
  '文件内容': 'File content',
  '在此输入文件内容...': 'Enter file content here...',
  '提示: 输入文件名时自动检测扩展名，或直接选择文件类型': 'Tip: the extension is detected from the file name, or you can select a file type directly.',
  '创建中…': 'Creating...',
  '创建文件': 'Create file',
  '新建文件夹': 'New folder',
  '文件夹名称': 'Folder name',
  '输入文件夹名称': 'Enter folder name',
  '绑定存储桶': 'Assign bucket',
  '使用默认桶': 'Use default bucket',
  '默认': 'Default',
  '此文件夹及其中的文件将存储到「': 'This folder and its files will be stored in "',
  '未指定时使用默认存储桶': 'Uses the default bucket when not specified',
  '创建': 'Create',
  '重命名': 'Rename',
  '确认': 'Confirm',
  '创建下载分享': 'Create download share',
  '（文件夹）': '(Folder)',
  '文件夹分享支持子文件列表浏览和 ZIP 打包下载': 'Folder shares support browsing files and downloading a ZIP archive',
  '访问密码（可选）': 'Access password (optional)',
  '留空则不设密码': 'Leave blank for no password',
  '有效天数（可选）': 'Validity in days (optional)',
  '留空则使用默认（7天）': 'Leave blank for the default (7 days)',
  '下载次数限制（可选）': 'Download limit (optional)',
  '留空则不限次数': 'Leave blank for unlimited downloads',
  '创建并复制链接': 'Create and copy link',
  '创建上传链接': 'Create upload link',
  '目标文件夹：': 'Destination folder:',
  '生成的链接允许任何人无需登录即可上传文件到此文件夹': 'Anyone with this link can upload files to this folder without signing in',
  '留空则无需密码': 'Leave blank for no password',
  '高级设置': 'Advanced settings',
  '单文件大小上限（MB，可选）': 'Maximum file size (MB, optional)',
  '留空则继承系统上限': 'Leave blank to use the system limit',
  '最多上传文件数（可选）': 'Maximum upload count (optional)',
  '留空则不限': 'Leave blank for no limit',
  '允许的文件类型（可选）': 'Allowed file types (optional)',
  '如 image/*,video/mp4（逗号分隔）': 'For example: image/*,video/mp4 (comma-separated)',
  '留空则继承文件夹类型限制': 'Leave blank to inherit the folder restrictions',
  '没有找到 "{{p0}}"': 'No results for "{{p0}}"',
  '换个关键词试试': 'Try a different search term',
  '拖放文件或整个文件夹到这里上传': 'Drop files or folders here to upload',
  '删除 "{{p0}}"？': 'Delete "{{p0}}"?',
  '将 "{{p0}}" 移入回收站？': 'Move "{{p0}}" to trash?',
  '隐藏 AI 信息': 'Hide AI information',
  '显示 AI 信息': 'Show AI information',
  '文件加载失败: {{p0}}': 'Failed to load file: {{p0}}',
  '正在加载表格...': 'Loading spreadsheet...',
  'CSV 表格 -': 'CSV spreadsheet -',
  '行数据': 'rows',
  '搜索...': 'Search...',
  '20行/页': '20 rows per page',
  '50行/页': '50 rows per page',
  '100行/页': '100 rows per page',
  '上一页': 'Previous page',
  '下一页': 'Next page',
  '正在加载电子书...': 'Loading ebook...',
  '目录': 'Contents',
  '隐藏目录': 'Hide contents',
  '显示目录': 'Show contents',
  '位置 {{p0}} / {{p1}}': 'Position {{p0}} / {{p1}}',
  '正在加载字体...': 'Loading font...',
  'AI 描述': 'AI description',
  '暂无描述，点击下方生成标签': 'No description yet. Generate tags below.',
  'Word 文档': 'Word document',
  'Excel 表格': 'Excel spreadsheet',
  'PowerPoint 演示文稿': 'PowerPoint presentation',
  'Office 文档': 'Office document',
  '暂不支持在线预览，请下载查看': 'Online preview is not supported. Download the file to view it.',
  '下载文件': 'Download file',
  '容器不可用': 'Preview container is unavailable',
  '文件内容为空': 'File content is empty',
  '文档渲染结果为空': 'Document rendering produced no content',
  '文档预览失败，请下载查看': 'Document preview failed. Download the file to view it.',
  'Excel 文件无工作表': 'This Excel file has no worksheets',
  '工作表不存在': 'Worksheet does not exist',
  '安全限制：含访问凭据或查询参数的链接不会发送至第三方 Office 服务，请使用本地预览或下载。表格仅显示单元格值。': 'Security restriction: links with credentials or query parameters are not sent to third-party Office services. Use local preview or download. Spreadsheets display cell values only.',
  '在线预览': 'Online preview',
  '切换到本地预览': 'Switch to local preview',
  'Office 文档预览': 'Office document preview',
  '正在渲染文档...': 'Rendering document...',
  '正在加载幻灯片...': 'Loading slides...',
  'PowerPoint 预览': 'PowerPoint preview',
  'PDF 文档': 'PDF document',
  '- 第 {{p0}}/{{p1}} 页': '- Page {{p0}} of {{p1}}',
  '正在加载 PDF...': 'Loading PDF...',
  '正在读取压缩包...': 'Reading archive...',
  '压缩包内容': 'Archive contents',
  '原始:': 'Original:',
  '压缩:': 'Compressed:',
  '压缩率:': 'Compression ratio:',
  '生成摘要失败': 'Failed to generate summary',
  '生成标签失败': 'Failed to generate tags',
  '安全限制：HTML/SVG 活动内容仅允许下载，不提供在线预览。': 'Security restriction: active HTML/SVG content can only be downloaded, not previewed online.',
  '缩小': 'Zoom out',
  '放大': 'Zoom in',
  '重置缩放': 'Reset zoom',
  '退出全屏': 'Exit fullscreen',
  '全屏': 'Fullscreen',
  '切换窗口大小': 'Change window size',
  '分享': 'Share',
  '编辑': 'Edit',
  '版本历史': 'Version history',
  '笔记': 'Notes',
  '预览加载失败': 'Failed to load preview',
  '图片': 'Images',
  '视频': 'Videos',
  '音频': 'Audio',
  '压缩包': 'Archives',
  '文本/代码': 'Text/code',
  '电子书': 'Ebooks',
  '字体': 'Fonts',
  '设置已保存': 'Settings saved',
  '格式错误': 'Invalid format',
  '请输入有效的 MIME 类型，如 image/png 或 image/*': 'Enter a valid MIME type, such as image/png or image/*',
  '设置此文件夹允许上传的文件类型': 'Set which file types can be uploaded to this folder',
  '预设类型': 'Preset types',
  '自定义类型': 'Custom types',
  '输入 MIME 类型，如 image/png': 'Enter a MIME type, such as image/png',
  '清除限制': 'Clear restrictions',
  '文件夹': 'Folder',
  '预览': 'Preview',
  '分享文件夹': 'Share folder',
  '直链管理': 'Manage direct links',
  '移动': 'Move',
  '管理': 'Manage',
  '读写': 'Read/write',
  '只读': 'Read-only',
  '移入回收站': 'Move to trash',
  '列表': 'List',
  '网格': 'Grid',
  '瀑布流': 'Masonry',
  '图库': 'Gallery',
  '新建/上传': 'Create/upload',
  '名称': 'Name',
  '大小': 'Size',
  '上传文件夹': 'Upload folder',
  '上传文件': 'Upload files',
  '标签: {{p0}}': 'Tag: {{p0}}',
  '搜索文件...': 'Search files...',
  '高级搜索': 'Advanced search',
  '搜索历史': 'Search history',
  '清空': 'Clear all',
  '语义搜索已开启': 'Semantic search enabled',
  '开启语义搜索': 'Enable semantic search',
  'FTS5全文搜索已开启': 'FTS5 full-text search enabled',
  '开启FTS5全文搜索': 'Enable FTS5 full-text search',
  '且': 'AND',
  '或': 'OR',
  '+ 添加': '+ Add',
  '清除': 'Clear',
  '文件名': 'File name',
  '类型': 'Type',
  '创建时间': 'Created',
  '修改时间': 'Modified',
  '标签': 'Tags',
  '包含': 'Contains',
  '等于': 'Equals',
  '开头是': 'Starts with',
  '结尾是': 'Ends with',
  '大于': 'Greater than',
  '小于': 'Less than',
  '值': 'Value',
  '权限已授予': 'Permission granted',
  '授权失败': 'Failed to grant permission',
  '权限已撤销': 'Permission revoked',
  '撤销失败': 'Failed to revoke permission',
  '请选择用户': 'Select a user',
  '请选择用户组': 'Select a group',
  '您是此文件的所有者，拥有完整管理权限': 'You own this file and have full management permissions',
  '授权': 'Grant permission',
  '授权对象': 'Grant to',
  '用户': 'User',
  '用户组': 'Group',
  '搜索用户': 'Search users',
  '搜索用户组': 'Search groups',
  '输入邮箱搜索...': 'Search by email...',
  '输入组名搜索...': 'Search by group name...',
  '搜索中...': 'Searching...',
  '未找到匹配的': 'No matching',
  '成员': 'Members',
  '权限级别': 'Permission level',
  '过期时间（可选）': 'Expiration (optional)',
  '暂无其他用户权限': 'No permissions for other users',
  '继承': 'Inherited',
  '已过期': 'Expired',
  '过期: {{p0}}': 'Expires: {{p0}}',
  '权限管理': 'Permission management',
  '您不是此': 'You do not own this',
  '文件': 'File',
  '的所有者，无法修改权限': 'and cannot change its permissions',
  '当前权限': 'Current permissions',
  '添加权限': 'Add permission',
  '输入用户邮箱搜索...': 'Search by user email...',
  '授予权限': 'Grant permission',
  '已收藏': 'Starred',
  '收藏': 'Star',
  '取消收藏': 'Unstar',
  '加载收藏文件失败': 'Failed to load starred files',
  '暂无收藏文件': 'No starred files',
  '点击文件旁的星星图标即可收藏': 'Click the star next to a file to add it to your starred files',
  '收藏文件': 'Starred files',
  '打开': 'Open',
  '存储空间': 'Storage',
  '{{p0}} 个更多标签': '{{p0}} more tags',
  '标签已添加': 'Tag added',
  '添加失败': 'Failed to add',
  '标签已移除': 'Tag removed',
  '移除失败': 'Failed to remove',
  '标签名称': 'Tag name',
  '确定要恢复到版本 {{p0}} 吗？这将创建一个新版本。': 'Restore version {{p0}}? This creates a new version.',
  '确定要删除版本 {{p0}} 吗？此操作不可撤销。': 'Delete version {{p0}}? This cannot be undone.',
  '设置': 'Settings',
  '版本设置': 'Version settings',
  '最大版本数': 'Maximum versions',
  '版本保留天数': 'Version retention (days)',
  '暂无版本历史记录': 'No version history',
  '版本': 'Version',
  '当前版本': 'Current version',
  '下载中...': 'Downloading...',
  '恢复中...': 'Restoring...',
  '恢复': 'Restore',
  '删除中...': 'Deleting...',
  '共': 'Total',
  '个版本 · 最多保留': 'versions · Maximum',
  '个版本 · 保留': 'versions · Retained for',
  '用户组已创建': 'Group created',
  '创建失败': 'Failed to create',
  '组名称不能为空': 'Group name is required',
  '组名称不能超过50个字符': 'Group name cannot exceed 50 characters',
  '创建用户组': 'Create group',
  '组名称': 'Group name',
  '例如：开发团队': 'For example: Development team',
  '描述（可选）': 'Description (optional)',
  '简要描述此用户组的用途...': 'Briefly describe the purpose of this group...',
  '用户组已删除': 'Group deleted',
  '删除失败': 'Failed to delete',
  '确定要删除用户组 "{{p0}}" 吗？此操作不可撤销。所有成员将被移除。': 'Delete group "{{p0}}"? This cannot be undone. All members will be removed.',
  '创建用户组以便批量授权给多个用户': 'Create groups to grant permissions to multiple users at once',
  '创建组': 'Create group',
  '暂无用户组': 'No groups',
  '创建一个用户组以便批量授权': 'Create a group to grant permissions in bulk',
  '创建第一个组': 'Create your first group',
  '所有者': 'Owner',
  '创建于': 'Created on',
  '管理成员': 'Manage members',
  '成员已添加': 'Member added',
  '成员已移除': 'Member removed',
  '确定要移除成员 "{{p0}}" 吗？': 'Remove member "{{p0}}"?',
  '管理组成员': 'Manage group members',
  '成员列表': 'Member list',
  '添加成员': 'Add member',
  '未找到匹配的用户': 'No matching users',
  '角色': 'Role',
  '普通成员': 'Member',
  '管理员': 'Administrator',
  '暂无成员': 'No members',
  '刚刚': 'Just now',
  '{{p0}} 分钟前': '{{p0}} minutes ago',
  '{{p0}} 小时前': '{{p0}} hours ago',
  '{{p0}} 天前': '{{p0}} days ago',
  '未知用户': 'Unknown user',
  '回复': 'Reply',
  '取消置顶': 'Unpin',
  '置顶': 'Pin',
  '已编辑 · 版本': 'Edited · Version',
  '隐藏': 'Hide',
  '显示': 'Show',
  '条回复': 'replies',
  '确定要删除这条回复吗？': 'Delete this reply?',
  '删除回复': 'Delete reply',
  '粗体': 'Bold',
  '斜体': 'Italic',
  '删除线': 'Strikethrough',
  '代码': 'Code',
  '提及用户': 'Mention user',
  '输入笔记内容...&#10;&#10;支持 Markdown 格式:&#10;**粗体** *斜体* ~~删除线~~ `代码`&#10;@user@example.com 提及用户': 'Enter note content...\n\nMarkdown supported:\n**bold** *italic* ~~strikethrough~~ `code`\n@user@example.com to mention a user',
  '加载笔记失败': 'Failed to load notes',
  '确定要删除这条笔记吗？': 'Delete this note?',
  '笔记已删除': 'Note deleted',
  '回复已删除': 'Reply deleted',
  '笔记已更新': 'Note updated',
  '笔记已创建': 'Note created',
  '新建笔记': 'New note',
  '暂无笔记': 'No notes',
  '点击"新建笔记"添加第一条笔记': 'Click "New note" to add your first note',
  '其他笔记': 'Other notes',
  '编辑笔记': 'Edit note',
  '回复笔记': 'Reply to note',
  '通知': 'Notifications',
  '加载通知失败': 'Failed to load notifications',
  '全部已读': 'Mark all as read',
  '暂无通知': 'No notifications',
  '标记已读': 'Mark as read',
  '授权成功': 'Permission granted',
  '权限已更新': 'Permission updated',
  '更新失败': 'Failed to update',
  '请选择至少一个文件或文件夹': 'Select at least one file or folder',
  '授权管理': 'Permission management',
  '查看和管理所有文件/文件夹的授权信息': 'View and manage permissions for all files and folders',
  '新增授权': 'Grant permission',
  '选择用户组': 'Select group',
  '搜索文件/文件夹': 'Search files/folders',
  '输入名称搜索...': 'Search by name...',
  '已选': 'Selected',
  '已选择': 'Selected',
  '项': 'items',
  '更多': 'more',
  '授权 (': 'Grant permission (',
  '项)': 'items)',
  '筛选:': 'Filter:',
  '全部对象': 'All subjects',
  '全部权限': 'All permissions',
  '条授权记录': 'permission records',
  '暂无授权记录': 'No permission records',
  '点击"新增授权"开始授权': 'Click "Grant permission" to get started',
  '条授权': 'permissions',
  '授权于': 'Granted on',
  '确定要撤销此权限吗？': 'Revoke this permission?',
  '权限说明': 'Permission guide',
  '权限级别说明': 'Permission levels',
  '可以查看文件和文件夹内容，但不能进行任何修改操作。': 'Can view file and folder contents, but cannot make changes.',
  '预览文件': 'Preview files',
  '浏览文件夹': 'Browse folders',
  '查看分享链接': 'View share links',
  '编辑文件': 'Edit files',
  '删除文件': 'Delete files',
  '管理权限': 'Manage permissions',
  '可以查看、编辑、上传和下载文件，但不能管理权限或删除文件。': 'Can view, edit, upload, and download files, but cannot manage permissions or delete files.',
  '拥有完整权限，包括查看、编辑、上传、下载、删除和权限管理。': 'Has full permissions, including viewing, editing, uploading, downloading, deleting, and managing permissions.',
  '用户组成员角色': 'Group member roles',
  '可以查看组内信息，当组被授权时自动获得相应权限。无法管理组成员或修改组信息。': 'Can view group information and inherits permissions granted to the group. Cannot manage members or change group information.',
  '组管理员': 'Group administrator',
  '可以添加/移除成员、修改成员角色、使用组进行文件授权。组所有者拥有最高权限，可以删除组。': 'Can add or remove members, change roles, and use the group to grant file permissions. The group owner has full permissions and can delete the group.',
  '权限继承': 'Permission inheritance',
  '当对文件夹授权时，权限会自动继承到该文件夹下的所有子文件和子文件夹。 例如：对「项目文档」文件夹授予用户「读写」权限，该用户将自动获得「项目文档」下所有内容的读写权限。': 'Folder permissions are inherited by all child files and folders. For example, granting read/write permission on a Project Documents folder also grants read/write access to all its contents.',
  '权限有效期': 'Permission validity',
  '授权时可以设置过期时间。过期后权限将自动失效，用户将无法继续访问相关资源。 如需继续访问，需要重新授权。': 'Permissions can have an expiration date. Expired permissions no longer allow access. Grant new permissions to restore access.',
  '我已了解': 'Got it',
  '读取文件': 'Read files',
  '列出、下载、搜索文件': 'List, download, and search files',
  '写入文件': 'Write files',
  '上传、修改、删除文件': 'Upload, modify, and delete files',
  '查看分享': 'View shares',
  '查看分享信息': 'View share information',
  '管理分享': 'Manage shares',
  '创建、删除分享': 'Create and delete shares',
  '查看存储桶': 'View buckets',
  '查看存储桶配置': 'View bucket configuration',
  '请输入名称': 'Enter a name',
  '请至少选择一个权限': 'Select at least one permission',
  '身份验证失败': 'Identity verification failed',
  '创建 API Key': 'Create API key',
  '例如：自动化脚本': 'For example: Automation script',
  '权限': 'Permissions',
  '永不过期': 'Never expires',
  '7 天后过期': 'Expires in 7 days',
  '30 天后过期': 'Expires in 30 days',
  '90 天后过期': 'Expires in 90 days',
  '1 年后过期': 'Expires in 1 year',
  '再次验证身份': 'Verify your identity again',
  '未启用两步验证时输入账户密码；已启用时输入当前验证码或恢复码。': 'Enter your account password if two-factor authentication is off. Otherwise, enter a current verification code or recovery code.',
  '账户密码': 'Account password',
  '账户密码（未启用两步验证）': 'Account password (two-factor authentication off)',
  '两步验证码或恢复码': 'Two-factor or recovery code',
  '两步验证码或恢复码（已启用）': 'Two-factor or recovery code (two-factor authentication on)',
  '管理员权限': 'Administrator permissions',
  '确定要删除 API Key "{{p0}}" 吗？此操作不可撤销。': 'Delete API key "{{p0}}"? This cannot be undone.',
  'API Key 已删除': 'API key deleted',
  'API Key 已禁用': 'API key disabled',
  'API Key 已启用': 'API key enabled',
  '从未': 'Never',
  '暂无 API Key': 'No API keys',
  '创建一个 API Key 用于程序化访问': 'Create an API key for programmatic access',
  '已禁用': 'Disabled',
  '禁用': 'Disable',
  '启用': 'Enable',
  '最后使用': 'Last used',
  '过期时间': 'Expires',
  '已复制到剪贴板': 'Copied to clipboard',
  '确定要关闭吗？关闭后将无法再次查看完整的 API Key。': 'Close this window? You will not be able to view the full API key again.',
  'API Key 创建成功': 'API key created',
  '重要提示': 'Important',
  '请立即保存此 API Key。关闭此窗口后将无法再次查看完整的密钥。': 'Save this API key now. The full key cannot be viewed again after closing this window.',
  '已复制': 'Copied',
  '复制': 'Copy',
  '使用方式：': 'Usage:',
  '在请求头中添加': 'Add to the request headers',
  '或使用': 'or use',
  '我已保存，关闭': 'Saved, close',
  '浏览器': 'Browser',
  '未知系统': 'Unknown system',
  '设备已注销': 'Device signed out',
  '注销失败': 'Failed to sign out device',
  '暂无已登录设备': 'No signed-in devices',
  '当前设备': 'Current device',
  '确定要注销此设备吗？': 'Sign out this device?',
  '注销': 'Sign out',
  '如果发现陌生设备登录，请立即修改密码并注销该设备': 'If you see an unfamiliar device, change your password and sign out that device immediately',
  '加载 WebDAV 应用凭据失败': 'Failed to load WebDAV application credentials',
  '创建失败，请检查密码或当前两步验证码': 'Failed to create. Check your password or current two-factor code.',
  'WebDAV 应用凭据': 'WebDAV application credentials',
  '开启两步验证后使用独立应用密码挂载 WebDAV；用户名仍为账户邮箱。默认只读、不过期，撤销后立即失效。': 'With two-factor authentication enabled, use a separate application password for WebDAV. The username remains your account email. Credentials default to read-only access with no expiration and stop working immediately when revoked.',
  '已撤销': 'Revoked',
  '不过期': 'No expiration',
  '已到期': 'Expired',
  '到期：{{p0}}': 'Expires: {{p0}}',
  '撤销': 'Revoke',
  '应用密码仅显示一次，请保存到 WebDAV 客户端。': 'This application password is shown only once. Save it in your WebDAV client.',
  '新建 WebDAV 应用密码': 'New WebDAV application password',
  '已保存，关闭显示': 'Saved, hide password',
  'WebDAV 凭据名称': 'WebDAV credential name',
  '应用名称，例如 Windows 挂载': 'Application name, such as Windows mount',
  'WebDAV 权限': 'WebDAV permissions',
  '创建前再次验证：未开启两步验证时输入密码；已开启时输入当前验证码或恢复码。': 'Verify again before creating: enter your password if two-factor authentication is off, or a current verification code or recovery code if it is on.',
  '再次验证账户密码': 'Verify account password again',
  '账户密码（未开启两步验证）': 'Account password (two-factor authentication off)',
  '再次验证两步验证码或恢复码': 'Verify two-factor or recovery code again',
  '两步验证码或恢复码（已开启）': 'Two-factor or recovery code (two-factor authentication on)',
  '创建应用凭据': 'Create application credentials',
  '文件操作': 'File operations',
  '全选': 'Select all',
  '删除选中项': 'Delete selected items',
  '打开文件/文件夹': 'Open file/folder',
  '视图切换': 'Switch views',
  '网格视图': 'Grid view',
  '列表视图': 'List view',
  '聚焦搜索框': 'Focus search',
  '导航': 'Navigation',
  '向上移动选择': 'Move selection up',
  '向下移动选择': 'Move selection down',
  '取消选择/关闭对话框': 'Clear selection/close dialog',
  '编辑操作': 'Editing',
  '剪切': 'Cut',
  '粘贴': 'Paste',
  '键盘快捷键': 'Keyboard shortcuts',
  '搜索快捷键...': 'Search shortcuts...',
  '没有找到匹配的快捷键': 'No matching shortcuts',
  'Mac 用户请将 Ctrl 替换为 ⌘ (Command)': 'On Mac, use Command instead of Ctrl',
  '安装应用': 'Install app',
  '将 OSSshelf 添加到主屏幕，获得更好的使用体验': 'Add OSSshelf to your home screen for a better experience',
  '暂不': 'Not now',
  '安装': 'Install',
  '网络已断开，部分功能可能不可用': 'You are offline. Some features may be unavailable.',
  '网络已恢复': 'You are back online',
  'Webhook 已创建': 'Webhook created',
  'URL 不能为空': 'URL is required',
  'URL 必须以 http:// 或 https:// 开头': 'URL must start with http:// or https://',
  '至少选择一个事件': 'Select at least one event',
  '请保存您的密钥': 'Save your secret',
  '此密钥仅显示一次。您需要用它来验证 Webhook 请求的签名。请妥善保存。': 'This secret is shown only once. You need it to verify webhook request signatures. Store it securely.',
  'Webhook 密钥': 'Webhook secret',
  '验证签名示例：': 'Signature verification example:',
  '我已保存密钥': 'I have saved the secret',
  '创建 Webhook': 'Create webhook',
  '回调 URL': 'Callback URL',
  '订阅事件': 'Subscribed events',
  '自定义密钥（可选）': 'Custom secret (optional)',
  '留空将自动生成': 'Leave blank to generate automatically',
  '密钥至少 8 个字符，用于验证请求签名': 'At least 8 characters, used to verify request signatures',
  'Webhook 已删除': 'Webhook deleted',
  '状态已更新': 'Status updated',
  '状态更新失败': 'Failed to update status',
  '测试事件已发送': 'Test event sent',
  '测试失败': 'Test failed',
  '确定要删除此 Webhook 吗？\n{{p0}}': 'Delete this webhook?\n{{p0}}',
  '所有事件': 'All events',
  '安全限制：Webhook 投递和测试已暂停，等待安全目标策略就绪。现有配置可查看和删除，启用状态不代表当前会发送事件。': 'Security restriction: webhook delivery and testing are paused until the safe destination policy is ready. Existing configurations can be viewed or deleted. Enabled status does not mean events are currently being sent.',
  '配置 Webhook 以接收文件系统事件通知': 'Configure webhooks to receive file system event notifications',
  '暂无 Webhook': 'No webhooks',
  '创建 Webhook 以接收事件通知': 'Create a webhook to receive event notifications',
  '创建第一个 Webhook': 'Create your first webhook',
  '上次状态:': 'Last status:',
  '未发送': 'Not sent',
};
